import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import DataNotFound from "../DataNotFound/DataNotFound";
import SpinerLoader from "src/utils/SpinerLoader";

const BlankSailingTracker = () => {
  const singleUrls = useSelector((state) => state.publicUrlState);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [pdfLoaded, setPdfLoaded] = useState(false);
  const [showNotFound, setShowNotFound] = useState(false);

  useEffect(() => {
    if (
      singleUrls &&
      singleUrls.singleUrls &&
      singleUrls.singleUrls.length > 0
    ) {
      const userCondition = singleUrls.singleUrls.find(
        ({ url_id }) => url_id === "blank_sailing_tracker"
      );

      const url = userCondition?.url_link;

      if (url && url.trim() !== "") {
        setPdfUrl(url);
        setShowNotFound(false);
        setPdfLoaded(false); // Show loader until iframe loads
      } else {
        setPdfUrl(null);
        setShowNotFound(true);
      }
    } else {
      setPdfUrl(null);
      setShowNotFound(true);
    }
  }, [singleUrls]);

  const handleIframeLoad = () => {
    setPdfLoaded(true);
  };

  return (
    <React.Fragment>
      {!pdfLoaded && !showNotFound && (
        <div style={styles.loader}>
          <SpinerLoader />
        </div>
      )}

      {showNotFound ? (
        <div style={styles.container}>
          <DataNotFound />
        </div>
      ) : (
        <div
          style={{
            ...styles.container,
            display: pdfLoaded ? "flex" : "none", // Hide iframe until PDF is fully loaded
          }}
        >
          <iframe
            src={pdfUrl + "#toolbar=0&navpanes=0&scrollbar=0"}
            width="100%"
            height="100%"
            title="Blank sailing tracker"
            allow="fullscreen"
            allowFullScreen
            onLoad={handleIframeLoad}
          />
        </div>
      )}
    </React.Fragment>
  );
};

const styles = {
  container: {
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    width: "100%",
    padding: "10px",
    boxSizing: "border-box",
  },
  loader: {
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    width: "100%",
    padding: "10px",
    boxSizing: "border-box",
  },
};

export default BlankSailingTracker;
